import ReaccessReferralSharePage from "./ReaccessReferralSharePage";
export default ReaccessReferralSharePage;
